export default {

  // Calendar Labels
  eventLabels: [],

  // Simple Calendar State
  events: []
}
